'use strict';
require('es6-promise').polyfill();
import axios from 'axios';

function validate() {
  return axios.get(`/_api/marketing-cookie-notification/show`);
}

export {validate, axios};



// WEBPACK FOOTER //
// ./modules/EUValitaor.js